<script lang="ts">
	import type { OperationModel } from '@app/models/api/OperationModel';
	import {
		getBusinessErrorFromCode,
		getMessageFromBusinessError
	} from '@app/models/api/enums/BusinessError';
	import Box from '$lib/components/boxes/Box.svelte';
	import Icon from '$lib/elements/Icon.svelte';
	import { t } from 'svelte-i18n';
	import ButtonText from '$lib/elements/buttons/variants/ButtonText.svelte';
	import { isDocsPendingValidation } from '@app/utils/user';
	import { page } from '$app/stores';
	import { urls } from '@app/urls';

	export let operation: OperationModel;
</script>

{#if operation.investErrors && operation.investErrors.length && !(operation.investErrors.length === 1 && operation.investErrors[0].code === 119)}
	<Box props={{ classNames: 'border border-grey-light space-y-3' }}>
		<div class="font-semibold">{$t('subscription.cantInvest')}</div>
		<ul>
			{#each operation.investErrors as error}
				{#if error.code !== 119}
					<li class="flex">
						<Icon name="warning" classNames="text-primary mr-2" />
						{@html getBusinessErrorFromCode(error.code) != null
							? getMessageFromBusinessError(getBusinessErrorFromCode(error.code), $t)
							: error.message}
						{#if isDocsPendingValidation($page?.data?.user)}
							<br />{$t('businessErrors.docsNotValid')}
						{/if}
					</li>
				{/if}
				{#if error.code === 134}
					<ButtonText
						props={{
							label: $t('profile.hasToDoKYC.ctaLabel'),
							classNames: 'text-danger pl-5 underline',
							href: urls.USER.ACCOUNT.PROFILE
						}}
					/>
				{/if}
			{/each}
		</ul>
	</Box>
{/if}
